type Props = {
  children: React.ReactNode
}

function ViewContainer({ children }: Props) {
  return <div className="view-container">{children}</div>
}

export function CenterContainer({ children }: Props) {
  return <div className="center-item">{children}</div>
}

export default ViewContainer
